const systemSettingsTranslationsEN = {
  socialLinksSectionHeader: 'Social media links',
  vatTaxInputLabel: 'Tax',
  taxSectionHeader: 'Value added tax',
  twitterInputLabel: 'Twitter',
  facebookInputLabel: 'Facebook',
  youtubeInputLabel: 'Youtube',
  linkedinInputLabel: 'Linkedin',
  tiktokInputLabel: 'TikTok',
  instagramInputLabel: 'Instagram',
  accountNumberInputLabel: 'Account number',
  beneficiaryNameInputLabel: 'Beneficiary name',
  swiftCodeInputLabel: 'Swift code',
  wireTransferSettings: 'Wire transfer settings',
  discountSettings: 'Discount for rushes',
  from1To4Videos: 'From 1 to 4 videos',
  from5To9Videos: 'From 5 to 9 videos',
  from10To14Videos: 'From 10 to 14 videos',
  from15AndAboveVideos: '15 videos and above',
};

export default systemSettingsTranslationsEN;
